export default __webpack_public_path__ + "static/media/4.2b6c1ef3.svg";